import { SortValues } from '@omniafishing/core';
import React from 'react';
import { ContentWrapper } from '../components/content_wrapper/content_wrapper';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';
import { TagProductsGridContainer } from '../components/tag_products_grid/tag_products_grid_container';
import styles from '../styles/common.less';

export const SalePage = () => {
  return (
    <ScrollToTop>
      <SEO title="Products on Sale"></SEO>
      <section className={styles.pageWrapper}>
        <ContentWrapper>
          <h1
            style={{
              fontSize: 65,
              fontWeight: 300,
              marginBottom: '20px',
            }}
          >
            Bargain Bin
          </h1>
        </ContentWrapper>
        <TagProductsGridContainer tag="on_sale" defaultSortValue={SortValues.BESTSELLING} />
      </section>
    </ScrollToTop>
  );
};

export default SalePage;
